import classnames from 'classnames';
import styles from './index.module.less';
import type { Tools } from '../../../core/types';
import { FontType, Size, Color } from '../../../core/enums';
import withEventTracking from '../../../utilities/withEventTracking';
import { Icon } from '../../atoms/icon';
import { Typography } from '../../archived/typography';

export interface CheckboxProps {
  label: React.ReactNode;
  onClick: (checked: boolean) => void;
  tools?: Tools;
  checked?: boolean;
  disabled?: boolean;
  invalid?: boolean;
  indeterminate?: boolean;
  qeId?: string;
  id?: string;
  className?: string;
}

export const Checkbox = ({
  label,
  onClick,
  checked,
  disabled,
  invalid,
  indeterminate,
  qeId = 'Checkbox',
  id,
  className = styles.focus,
}: CheckboxProps) => (
  <div className={classnames(styles.root, className)}>
    <input
      data-qe-id={qeId}
      id={id ?? (typeof label === 'string' ? (label as string) : qeId)}
      disabled={disabled}
      aria-invalid={invalid}
      type="checkbox"
      checked={checked}
      onChange={(event) => onClick(event.target.checked)}
    />
    <label htmlFor={id || qeId}>
      <Typography
        Component="span"
        $size="1rem"
        $family={FontType.HelveticaRegular}
        $lineHeight="1.5rem"
      >
        {label}
      </Typography>
      <div className={styles.icon}>
        <Icon
          $size={Size.XS}
          Component="span"
          theme={{ color: Color.White }}
          imageName={
            indeterminate ? 'dls-icon-minus-filled' : 'dls-icon-check-filled'
          }
          directory="dls"
        />
      </div>
    </label>
  </div>
);

Checkbox.defaultProps = {
  tools: {
    tracking: {
      methods: ['click'],
    },
  },
};

export default withEventTracking<CheckboxProps>(Checkbox);
